<template>
  <b-modal
    id="ConfirmSelectionDialog"
    centered
    no-close-on-backdrop
    hide-header-close
    hide-footer
  >
    <template #modal-title>Confirme la selección</template>

    <template #default="{cancel}">
      <div>
        La consulta sin especificación de parámetros puede traer un conjunto de resultados muy grande
        y tardar en visualizarse en el navegador, ¿desea continuar?
      </div>

      <FormulateForm ref="exportForm" #default="{ hasErrors, isLoading }" @submit="submit">
        <!-- Submit -->
        <x-form-footer-buttons
          :disabled="hasErrors || isLoading"
          :loading="isLoading"
          :isEditing="false"
          :isCreating="true"
          btnCreateTitle="Confirmar"
          btnCreateType="submit"
        >
          <template #cancel>
            <b-button variant="black" size="sm" @click="cancel">Cancelar</b-button>
          </template>
        </x-form-footer-buttons>
      </FormulateForm>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'ConfirmSelectionDialog',

  methods: {
    async submit () {
      this.$emit('on-submitted')
    }
  }
}
</script>
